<template>
	<PrimeDataTable
		v-if="tableData"
		sortMode="single"
		sortField="camera_full_name"
		:sortOrder="1"
		rowGroupMode="rowspan"
		groupRowsBy="camera_full_name"
		:value="tableData"
		showGridlines
		stripedRows
		dataKey="camera_full_name"
	>
		<PrimeColumn field="camera_full_name" header="Camera" />
		<PrimeColumn field="lens_name" header="Lens" />
		<PrimeColumn field="count" header="Count" />
	</PrimeDataTable>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";

import { supabase } from "@/ts/supabase";

export default defineComponent({
	name: "StatsMonthlyCameraLensesTopTable",
	components: {
		PrimeDataTable,
		PrimeColumn
	},
	setup() {
		const tableData = ref();

		onMounted(async () => {
			const { data, error } = await supabase.rpc("stats_get_camera_lens_stats", {
				stats_period: "1 month"
			});

			if (error) {
				console.error(error);
				return;
			}

			tableData.value = data.map((row) => ({
				...row,
				camera_full_name: `${row.camera_make} - ${row.camera_model}`
			}));
		});

		return { tableData };
	}
});
</script>
<style scoped>
:deep(.p-datatable-column-sorted) {
	background: inherit;
	color: inherit;
}
</style>
